import React, { useLayoutEffect } from "react";

import {Redirect, Route} from "react-router-dom";

import * as routes from "./routes";

import {notifyError} from "./toast-notifications";
import { GET_CONNECTED_USER_NOT_CONNECTED_ERROR } from "./errors";

import { getConnectedUser } from "./store/actions";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";


const PrivateRoute = ({
    component: Component,
    ...props
}) => {

    const isFirstAuthentication = props.isUserAuthenticated === null;
    const isAuthenticated = !!props.isUserAuthenticated;

    useLayoutEffect(() => {
        if(isFirstAuthentication)
            props.onGetAuthenticatedUser();
        else if(!isFirstAuthentication && !isAuthenticated)
            notifyError(GET_CONNECTED_USER_NOT_CONNECTED_ERROR);
    }, [isFirstAuthentication, isAuthenticated]);

    const RouteRenderer = rendererProps => isAuthenticated? <Component {...rendererProps} />: <Redirect to={routes.LOGIN}/>;

    return <>
        <Dimmer active={isFirstAuthentication}>
            <Loader />
        </Dimmer>

        {!isFirstAuthentication && 
            <Route 
                {...props} 
                render={RouteRenderer} 
            />
        }
    </>
};

const mapStateToProps = state => {
    return {
        isUserAuthenticated: state.authenticationReducer.isUserAuthenticated,
        userAuthenticationError: state.authenticationReducer.connectedUserError,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetAuthenticatedUser: () => dispatch(getConnectedUser()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/PrivateRoute.js